<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="w-lg-75 text-center mx-lg-auto">
                        <div class="mb-5 h1 text-muted">
                            <propertyiconeditor v-if="BlockProps.Icon1.Show" :blockprops="BlockProps" :inline="true" v-model:icon="BlockProps.Icon1" :prompt="'Header Icon (click to change)'"></propertyiconeditor>&nbsp;<omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Header" tag-name="span" :init="EditorConfig" />
                        </div>

                        <figure class="blockquote-lg">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Quote" class="blockquote fw-bold" tag-name="blockquote" :init="EditorConfig" />
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Caption" class="blockquote-footer mb-3 mb-sm-7 fw-light" tag-name="figcaption" :init="EditorConfig" />
                        </figure>

                        <span class="small text-muted">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Footer" tag-name="span" :init="EditorConfig" />
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>                                                
                        <propertycoloreditor :propertyname="'InnerColor'" :blockprops="BlockProps" :prompt="'Inner Background Color'"></propertycoloreditor>
                        <propertytogglededitor propertyname="Show" :blockprops="BlockProps.Icon1" prompt="Show Header Icon"></propertytogglededitor>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'Quote',
        mixins: [ContentBlockBase],
        props: [],
        components: {
        },
        computed:
        {
            RenderDirection() {
                if (!this.BlockProps.Flipped) {
                    return { "flex-direction": "column" };
                } else {
                    return { "flex-direction": "column-reverse" };
                }
            }
        },
        data() {
            return {  
         
            };
        },
        methods:
        {
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
          
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            EventHub.$on('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        beforeUnmount()
        {
            EventHub.$off('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        mounted() {
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

